<template>
  <transition name="dropdown-fade">
    <div
      v-show="visible"
      class="nav-dropdown"
      @mouseenter="$emit('enter')"
      @mouseleave="$emit('leave')"
    >
      <template v-for="(item, idx) in items">
        <div
          v-if="item.disabled"
          :key="'disabled-' + idx"
          class="dropdown-item is-disabled"
        >
          <span class="dropdown-item-title">{{ item.title }}</span>
          <span v-if="item.isNew" class="dropdown-item-badge">NEW</span>
        </div>
        <nav-link
          v-else
          :key="idx"
          :to="item.path"
          :href="item.href || item.path"
          :external="item.external"
          :link-class="['dropdown-item', { 'is-active': isItemActive(item) }]"
          suppress-active-class
          @click="$emit('navigate')"
        >
          <span class="dropdown-item-title">{{ item.title }}</span>
          <span v-if="item.isNew" class="dropdown-item-badge">NEW</span>
        </nav-link>
      </template>
    </div>
  </transition>
</template>

<script>
import NavLink from '@/components/common/NavLink.vue'
import { getNavLinkKey, getUniqueActiveNavKey } from '@/utils/navigation'

export default {
  name: 'NavDropdown',
  components: { NavLink },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    activeItemKey() {
      return getUniqueActiveNavKey(this.items, this.$route)
    }
  },
  methods: {
    isItemActive(item) {
      if (!this.activeItemKey) return false
      return getNavLinkKey(item) === this.activeItemKey
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 220px;
  width: max-content;
  max-width: 320px;
  padding: 8px 0;
  background: $white;
  border: 1px solid $border-color;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 1002;

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid $white;
    filter: drop-shadow(0 -1px 0 $border-color);
  }
}

::v-deep .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 20px;
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  transition: $transition;

  &:hover,
  &.is-active {
   // @include brand-gradient-bg;
   @include brand-gradient-text;

    // .dropdown-item-title {
    //   color: $white;
    // }
  }

  &.is-disabled {
    cursor: default;

    &:hover {
      @include brand-gradient-text;

      // .dropdown-item-title {
      //   color: #000;
      // }
    }
  }
}

.dropdown-item-title {
  flex: 1;
  font-weight: 500;
  color: #666;
  transition: $transition;
}

.dropdown-item-badge {
  flex-shrink: 0;
  padding: 1px 6px;
  background: $primary-color;
  color: $white;
  font-size: 10px;
  border-radius: 3px;
  line-height: 1.4;
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

@media (max-width: 768px) {
  .nav-dropdown {
    display: none;
  }
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}
</style>
